
import Vue from "vue";
import { mapMutations } from "vuex";
import SearchForm from "@/components/PaymentIntegrity/SearchForm";
import Tables from "@/components/PaymentIntegrity/Tables";
import SelectedRecord from "@/components/PaymentIntegrity/SelectedRecord";

export default Vue.extend({
  name: "PaymentIntegrity",
  components: {
    SearchForm,
    Tables,
    SelectedRecord
  },
  data() {
    return {
      dialog: false,
      stepper: 1,
      loading: false,
      errorMessage: "",
      selectedID: 0,
      dueYet: ""
    };
  },
  methods: {
    ...mapMutations(["modify"]),
    nextStep(): void {
      this.stepper++;
      this.dialog = false;
    },
    reset(): void {
      this.stepper = 1;
    },
    back(): void {
      this.stepper = this.stepper - 1;
    },
    addErrorMessage(msg: string): void {
      this.errorMessage = msg;
      this.preloader();
    },
    preloader(): void {
      this.dialog = true;
    },
    selected(id: number, dueYet: string): void {
      this.stepper++;
      this.modify({ property: "dueYet", value: dueYet });
      this.modify({ property: "changedId", value: id });
    }
  }
});
